"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var vdl_prefix_1 = require("../util/vdl-prefix");
var classnames_1 = require("../util/classnames");
exports.AlertNumberIndicator = function (props) {
    var className = props.className, alertNumber = props.alertNumber;
    return React.createElement("div", { className: classnames_1.classNames(className, vdl_prefix_1.vdlPrefix('alert-number-indicator')) }, alertNumber);
};
exports.AlertNumberIndicator.propTypes = {
    alertNumber: PropTypes.number,
    className: PropTypes.string
};
exports.AlertNumberIndicator.displayName = 'AlertNumberIndicator';
